export default __webpack_public_path__ + "static/cruiselines-royal-activities-4-f770e4846a51bdfc90efd6346b976383.jpg";